import type {Theme} from '@mui/material/styles';

/**
 * Vertical divider before prior-year Final.
 * Same technique as F1 PPE section dividers (survives border-collapse).
 */
export const PRIOR_YEAR_DIVIDER_SX = {
    boxShadow: (theme: Theme) => `inset 2px 0 0 0 ${theme.palette.text.primary}`,
};
